import { House } from 'lucide-react'
import { getEventDate } from 'src/helpers/get-event-date'
import {
  CONFIRMATION_DATE_FORMAT,
  CONFIRMATION_TIME_FORMAT,
} from 'src/modules/confirmation/constants/cancellation-policy.constants'
import { formatInEventZone } from 'src/modules/confirmation/utils'
import { FormattedText, Icon, Typography } from 'src/modules/core/components'
import type { ConfirmationEventDetailsProps, DetailRowProps } from './confirmation-event-details.interface'
import classes from './confirmation-event-details.module.scss'

function DetailRow({ icon, children }: DetailRowProps) {
  return (
    <div className={classes.row}>
      <div className={classes.iconWrapper}>{icon}</div>
      <Typography variant="body">{children}</Typography>
    </div>
  )
}

export function ConfirmationEventDetails({ event, struckDate = false }: ConfirmationEventDetailsProps) {
  const eventDate = getEventDate(event)
  const dateLine = (
    <>
      {formatInEventZone(eventDate, event.timezone, CONFIRMATION_DATE_FORMAT)}
      {event.all_day ? (
        <FormattedText id="reminder.allDay" />
      ) : (
        formatInEventZone(eventDate, event.timezone, CONFIRMATION_TIME_FORMAT)
      )}
    </>
  )

  return (
    <>
      <DetailRow icon={<Icon name="info" />}>{event.title || <FormattedText id="reminder.noTitle" />}</DetailRow>
      {event.business_name && (
        <DetailRow icon={<House size={22} className={classes.businessIcon} aria-hidden="true" />}>
          {event.business_name}
        </DetailRow>
      )}
      <DetailRow icon={<Icon name="calendarAlt" />}>
        {struckDate ? <s className={classes.struck}>{dateLine}</s> : dateLine}
      </DetailRow>
      {event.location && <DetailRow icon={<Icon name="pin" />}>{event.location}</DetailRow>}
    </>
  )
}
